import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Modal, Services, Text, TextInput, NumberInput, Theme } from '@simplybenefits/sb-ui-library';
import Grid from "@mui/material/Grid";
import { Cancel as CancelIcon } from '@mui/icons-material';

class EobProceduresModal extends PureComponent {
    state = {
        eobProcedures: this.props.eobProcedures || []
    };

    _saveData = () => {
        this.props.saveData(this.state.eobProcedures, 'eobProcedures');
    };

    _validateForm = async () => {
        let isValid = true;

        const promises = this.state.eobProcedures.map(async (procedure, index) => {
            const eligibleAmountError = await Services.validateInput('checkEmpty', procedure.eligibleAmount);
            const deductibleAmountError = await Services.validateInput('checkEmpty', procedure.deductibleAmount);
            const benefitAmountForProcedureError = await Services.validateInput('checkEmpty', procedure.benefitAmountForProcedure);

            this.setState({
                [`eligibleAmountError${ index }`]: eligibleAmountError,
                [`deductibleAmountError${ index }`]: deductibleAmountError,
                [`benefitAmountForProcedureError${ index }`]: benefitAmountForProcedureError
            });

            if (
                eligibleAmountError ||
                deductibleAmountError ||
                benefitAmountForProcedureError
            ) {
                isValid = false;
                return false;
            }

            return true;
        });

        await Promise.all(promises);
        return isValid;
    };

    _next = async () => {
        const isValid = await this._validateForm();

        if (!isValid) {
            return;
        }

        await this._saveData();
        this.props.next();
    };

    _handleArrayItemChange = (type, index, key, e, isValue = false) => {
        this.setState({
            [type]: this.state[type].map((item, i) => {
                if (index !== i) {
                    return item;
                }

                return {
                    ...item,
                    [key]: isValue ? e : e.target.value
                };
            })
        });
    };

    _createProcedure = () => {
        const procedure = {
            eligibleAmount: '',
            deductibleAmount: '',
            eligiblePercentage: '',
            benefitAmountForProcedure: '',
            labProcedure1EligibleAmount: '',
            labProcedure1DeductibleAmount: '',
            labProcedure1EligiblePercentage: '',
            labProcedure1BenefitAmount: '',
            labProcedure2EligibleAmount: '',
            labProcedure2DeductibleAmount: '',
            labProcedure2EligiblePercentage: '',
            labProcedure2BenefitAmount: '',
            note1: '',
            note2: ''
        };

        this.setState({
            eobProcedures: [ ...this.state.eobProcedures, procedure ]
        });
    };

    _removeProcedure = (index) => {
        this.setState({
            eobProcedures: this.state.eobProcedures.filter((item, i) => i !== index)
        });
    };

    render() {
        const styles = {
            container: {
                flex: 1,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                marginBottom: 5
            },
            details: {
                flex: 1,
                flexDirection: 'column',
                marginBottom: 20
            }
        };

        return (
            <Modal
                medium
                testid="submit-claim-modal"
                aria-labelledby="Submit Claim"
                open={true}
                title={ this.props.title }
                primaryButton={
                    this.state.eobProcedures.length > 0
                        ? {
                            label: "Next",
                            onClick: this._next
                        }
                        : null
                }
                secondaryButton={ 
                    this.state.eobProcedures.length < 7 ?
                        {
                            label: "Add EOB Procedure",
                            onClick: this._createProcedure
                        } 
                        : null
                }
                onClose={ this.props.onClose}
                loader={ this.props.loader }
                onBack={ this.props.onBack }
            >
                <Text mediumLarge margin="10px 0">
                        EOB Procedures
                </Text>

                {
                    this.state.eobProcedures.map((procedure, index) => (
                        <div style={ styles.procedureBlock }>
                            <Text medium bold color={ Theme.colors.skyBlue } margin="10px 0">
                                    Procedure { index + 1 }

                                <CancelIcon
                                    onClick={ () => this._removeProcedure(index) }
                                    style={{ cursor: 'pointer', paddingTop: 10 }}
                                />
                            </Text>

                            <Grid
                                container
                                spacing={1}
                            >
                                <Grid item xs={12} sm={6} >
                                    <NumberInput
                                        prefix="$"
                                        label="Eligible Amount"
                                        variant="outlined"
                                        value={ procedure.eligibleAmount }
                                        onChange={ (e) => this._handleArrayItemChange('eobProcedures', index, 'eligibleAmount', e) }
                                        required
                                        fullWidth
                                        error={Boolean(this.state[`eligibleAmountError${ index }`])}
                                        helperText={this.state[`eligibleAmountError${ index }`]}
                                        margin="0"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6} >
                                    <NumberInput
                                        suffix="%"
                                        label="Eligible Percentage"
                                        variant="outlined"
                                        value={ procedure.eligiblePercentage }
                                        onChange={ (e) => this._handleArrayItemChange('eobProcedures', index, 'eligiblePercentage', e) }
                                        fullWidth
                                        margin="0"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6} >
                                    <NumberInput
                                        prefix="$"
                                        label="Deductible Amount"
                                        variant="outlined"
                                        value={ procedure.deductibleAmount }
                                        onChange={ (e) => this._handleArrayItemChange('eobProcedures', index, 'deductibleAmount', e) }
                                        required
                                        fullWidth
                                        error={Boolean(this.state[`deductibleAmountError${ index }`])}
                                        helperText={this.state[`deductibleAmountError${ index }`]}
                                        margin="0"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6} >
                                    <NumberInput
                                        prefix="$"
                                        label="Benefit Amount"
                                        variant="outlined"
                                        value={ procedure.benefitAmountForProcedure }
                                        onChange={ (e) => this._handleArrayItemChange('eobProcedures', index, 'benefitAmountForProcedure', e) }
                                        required
                                        fullWidth
                                        error={Boolean(this.state[`benefitAmountForProcedureError${ index }`])}
                                        helperText={this.state[`benefitAmountForProcedureError${ index }`]}
                                        margin="0"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6} >
                                    <NumberInput
                                        prefix="$"
                                        label="Lab Procedure 1 Eligible Amount"
                                        variant="outlined"
                                        value={ procedure.labProcedure1EligibleAmount }
                                        onChange={ (e) => this._handleArrayItemChange('eobProcedures', index, 'labProcedure1EligibleAmount', e) }
                                        fullWidth
                                        margin="0"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6} >
                                    <NumberInput
                                        suffix="%"
                                        label="Lab Procedure 1 Eligible Percentage"
                                        variant="outlined"
                                        value={ procedure.labProcedure1EligiblePercentage }
                                        onChange={ (e) => this._handleArrayItemChange('eobProcedures', index, 'labProcedure1EligiblePercentage', e) }
                                        fullWidth
                                        margin="0"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6} >
                                    <NumberInput
                                        prefix="$"
                                        label="Lab Procedure 1 Deductible Amount"
                                        variant="outlined"
                                        value={ procedure.labProcedure1DeductibleAmount }
                                        onChange={ (e) => this._handleArrayItemChange('eobProcedures', index, 'labProcedure1DeductibleAmount', e) }
                                        fullWidth
                                        margin="0"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6} >
                                    <NumberInput
                                        prefix="$"
                                        label="Lab Procedure 1 Benefit Amount"
                                        variant="outlined"
                                        value={ procedure.labProcedure1BenefitAmount }
                                        onChange={ (e) => this._handleArrayItemChange('eobProcedures', index, 'labProcedure1BenefitAmount', e) }
                                        fullWidth
                                        margin="0"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6} >
                                    <NumberInput
                                        prefix="$"
                                        label="Lab Procedure 2 Eligible Amount"
                                        variant="outlined"
                                        value={ procedure.labProcedure2EligibleAmount }
                                        onChange={ (e) => this._handleArrayItemChange('eobProcedures', index, 'labProcedure2EligibleAmount', e) }
                                        fullWidth
                                        margin="0"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6} >
                                    <NumberInput
                                        suffix="%"
                                        label="Lab Procedure 2 Eligible Percentage"
                                        variant="outlined"
                                        value={ procedure.labProcedure2EligiblePercentage }
                                        onChange={ (e) => this._handleArrayItemChange('eobProcedures', index, 'labProcedure2EligiblePercentage', e) }
                                        fullWidth
                                        margin="0"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6} >
                                    <NumberInput
                                        prefix="$"
                                        label="Lab Procedure 2 Deductible Amount"
                                        variant="outlined"
                                        value={ procedure.labProcedure2DeductibleAmount }
                                        onChange={ (e) => this._handleArrayItemChange('eobProcedures', index, 'labProcedure2DeductibleAmount', e) }
                                        fullWidth
                                        margin="0"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6} >
                                    <NumberInput
                                        prefix="$"
                                        label="Lab Procedure 2 Benefit Amount"
                                        variant="outlined"
                                        value={ procedure.labProcedure2BenefitAmount }
                                        onChange={ (e) => this._handleArrayItemChange('eobProcedures', index, 'labProcedure2BenefitAmount', e) }
                                        fullWidth
                                        margin="0"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6} >
                                    <TextInput
                                        label="Note Line 1"
                                        variant="outlined"
                                        value={ procedure.note1 }
                                        onChange={ (e) => this._handleArrayItemChange('eobProcedures', index, 'note1', e) }
                                        fullWidth
                                        margin="0"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6} >
                                    <TextInput
                                        label="Note Line 2"
                                        variant="outlined"
                                        value={ procedure.note2 }
                                        onChange={ (e) => this._handleArrayItemChange('eobProcedures', index, 'note2', e) }
                                        fullWidth
                                        margin="0"
                                    />
                                </Grid>
                            </Grid>
                        </div>
                    ))
                }
            </Modal>
        );
    }
}

export default connect()(EobProceduresModal);